<template>
    <div class="mb-5">
        <slot name="header"></slot>
        <div class="profile__file" v-if="uploadedFile">
            <a
                :href="`/uploads/${uploadedFile.file_path}`"
                target="_blank"
            >
                <i class="fas fa-file"></i> {{ uploadedFile.original_filename }}</a>
            <button
                class="delete"
                @click.prevent="showDeleteModal(uploadedFile.id, 'attachment')"
            >
                <svg width="16" height="16">
                    <use href="/img/svg/symbol-defs.svg#icon-close-9"></use>
                </svg>
            </button>
            <ActionModal confirm-text="Yes"
                         reject-text="No"
                         :modalId="getDeleteModalId(uploadedFile.id, 'attachment')"
                         @confirm="deleteSelectedFile(uploadedFile.id)">
                <template #body>
                    <div class="text-center mb-4">
                        <div class="text-center">
                            <h5 class="title">Are you sure ?</h5>
                            <p>Do you want to delete this item?</p>
                        </div>
                    </div>
                </template>
            </ActionModal>
        </div>
        <a
            href="javascript:void(0)"
            class="btn btn_primary-outline w-100"
            v-else
            @click="$refs.fileInput.click()"
        >
            upload File
        </a>
        <input
            type="file"
            style="display: none"
            @change="selectFile"
            ref="fileInput"
        >
    </div>

</template>

<script>
import ModalHandler from "../../mixins/ModalHandler";
import FileService from "../../services/FileService";
import ActionModal from "./ActionModal.vue";


export default {
    name: "FileContainer",
    components: {ActionModal},
    props: {
        fileInfo: {
            type: Object
        },
        userId: Number,
        field: String,
    },
    mixins: [ModalHandler],
    data() {
        return {
            uploadedFile: null
        }
    },
    methods: {
        deleteSelectedFile() {
            this.uploadedFile = null
            this.$emit('upload-file', null, this.field)
            this.$showSuccessMessage()
        },
        async readFileAsync(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = () => resolve(reader.result);
                reader.onerror = reject;
                reader.readAsDataURL(file);
            });
        },
        async selectFile(event) {
            const uploadedFiles = this.$refs.fileInput.files;
            if (!uploadedFiles || uploadedFiles.length === 0) {
                return;
            }

            const uploadedFile = uploadedFiles[0];
            try {
                const content = await this.readFileAsync(uploadedFile);
                const file = {
                    file: uploadedFile,
                    name: uploadedFile.name,
                    content,
                }
                await this.sendFileForGettingInfo(file)
            } catch (error) {
                console.error("Error reading file:", error);
            }
        },
        async sendFileForGettingInfo(file) {
            const formData = new FormData();
            formData.append('file', file.file);
            try {
                const {data: response} = await FileService.uploadFile(this.userId, formData);
                this.uploadedFile = response
                this.$emit('upload-file', this.uploadedFile, this.field)

            } catch (error) {
                this.$showErrorMessage('File was not uploaded');
            }
        }
    },
    mounted() {
        this.uploadedFile = this.fileInfo;

        this.$emit('upload-file', this.uploadedFile, this.field);
    },
    watch: {
        fileInfo(val) {
            if (val !== null) {
                this.uploadedFile = val;

                this.$emit('upload-file', this.uploadedFile, this.field);
            }
        },
    },

}

</script>


<style scoped>

</style>
